export default __webpack_public_path__ + "static/media/testimonial-watermark.aede6a2d.png";